import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'
import { blogSubscriptionsApi } from '../../api/api.blog.subcriptions.service'

export default {
  [actionTypes.GET_REGISTER_LOCATIONS](store) {
    if (
      store.getters.registerLocations &&
      store.getters.registerLocations.length > 0
    ) {
      return Promise.resolve()
    } else {
      return blogSubscriptionsApi.getBlogRegistrationLocations().then(res => {
        return store.commit(mutationTypes.SET_REGISTER_LOCATIONS, res)
      })
    }
  },
  [actionTypes.GET_PROVINCES](store) {
    if (store.getters.provinces && store.getters.provinces.length > 0) {
      return Promise.resolve()
    } else {
      return blogSubscriptionsApi.getBlogProvinces().then(res => {
        return store.commit(mutationTypes.SET_PROVINCES, res)
      })
    }
  },
}
